module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"de":{"Individual item to shop":"Einzelner Eintrag","Salt":"Salz","Add item":"Eintrag hinzufügen"}}')
  delete Component.options._Ctor
}
